document.addEventListener("DOMContentLoaded", function(event) {
    const toggles = document.querySelectorAll('[data-list-toggle]'),
        lists = document.querySelectorAll('[data-product-list]');

    toggles.forEach(toggle => {
        toggle.addEventListener('click', () => {
            [...toggles, ...lists].forEach(el => {
                el.classList.remove('is-active');
            });

            toggle.classList.add('is-active');
            toggle.nextElementSibling.classList.add('is-active');
        })
    });
});